import * as types from '../constant'

export function getTerm(payload) {
    return ({
        type: types.GET_TERM_REQUEST,
        payload
    });
}